import {
  SlAlert
} from "./chunk.YK3ND3ZE.js";

// src/components/alert/alert.ts
var alert_default = SlAlert;
SlAlert.define("sl-alert");

export {
  alert_default
};
